import styled from 'styled-components'

export const ReviewPromptWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  padding: ${({ theme }) => theme.spacing.sm}rem;
`

export const ReviewPromptCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}rem;
  width: min(480px, 100%);
  padding: ${({ theme }) => theme.spacing.xl}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
  border-radius: ${({ theme }) => theme.borderRadius.lg}rem;
`

export const ReviewPromptTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;

  h2 {
    margin: 0;
    font-size: ${({ theme }) => theme.fontSize.xl}rem;
  }

  p {
    color: ${({ theme }) => theme.colors.metalGray};
    margin: 0;
    line-height: 1.5;
    font-size: ${({ theme }) => theme.fontSize.md}rem;
  }
`

export const ReviewPromptActionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  width: 100%;

  & > button {
    align-self: flex-end;
  }
`
